import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { MessageCircle } from "lucide-react";
import { track } from "@/lib/analytics";

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: "Wat kost een Loxone smart home systeem?",
    answer: "Een Loxone systeem kost tussen €5.000-€25.000 afhankelijk van de grootte van uw woning en gewenste functionaliteiten. Voor een gemiddelde woning rekent u op €10.000-€15.000. Door energiebesparingen van 30-40% verdient het systeem zichzelf terug binnen 5-8 jaar."
  },
  {
    question: "Kan Loxone geïnstalleerd worden in een bestaande woning?",
    answer: "Ja, Loxone kan perfect geïnstalleerd worden in bestaande woningen. Door gebruik van draadloze Tree-technologie en slimme installatietechnieken minimaliseren we de verbouwingsimpact. In 80% van de gevallen is geen haktrek werk nodig."
  },
  {
    question: "Hoe betrouwbaar is het Loxone systeem?",
    answer: "Loxone heeft een uptime van 99.9% en werkt volledig lokaal zonder internetafhankelijkheid. Het systeem draait op industriële hardware en gebruikt geen cloud-diensten, waardoor uw privacy gegarandeerd is en het systeem altijd beschikbaar blijft."
  },
  {
    question: "Hoeveel energie bespaart een Loxone systeem?",
    answer: "Gemiddeld besparen klanten 30-40% op hun energierekening door intelligente automatisering. Het systeem optimaliseert verwarming, koeling, verlichting en zonnepaneel opbrengst. Bij een energierekening van €2.000/jaar betekent dit €600-€800 besparing."
  },
  {
    question: "Verschil tussen Loxone en andere smart home systemen?",
    answer: "Loxone is een totaaloplossing met één centrale intelligentie, terwijl andere systemen vaak losse apps en componenten zijn. Loxone werkt lokaal (geen cloud), heeft industriële betrouwbaarheid en leert automatisch uw gewoontes aan."
  },
  {
    question: "Kan Loxone samenwerken met bestaande slimme apparaten?",
    answer: "Ja, Loxone werkt samen met 300+ merken en protocollen zoals Philips Hue, Sonos, Tesla, KNX en vele anderen. Bestaande investeringen kunnen vaak behouden blijven en geïntegreerd worden in het Loxone systeem."
  },
  {
    question: "Hoe lang duurt een Loxone installatie?",
    answer: "Een basisinstallatie duurt 2-5 dagen afhankelijk van de omvang. Voor bestaande woningen met minimale bekabeling vaak slechts 1-2 dagen. Nieuwe bouw wordt meegenomen in het bouwproces voor optimaal resultaat."
  },
  {
    question: "Wat gebeurt er bij een storing of defect?",
    answer: "SOL-VI biedt volledige service en ondersteuning. Het systeem heeft ingebouwde diagnostiek die problemen voorspelt. Bij hardware defecten hebben we vervangende onderdelen op voorraad voor snelle oplossing binnen 24 uur."
  }
];

export const SmartHomeFAQ = () => {
  return (
    <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Veelgestelde Vragen over <span className="text-primary">Loxone Smart Home</span>
            </h2>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Alle antwoorden op uw vragen over Loxone systemen, kosten, installatie en mogelijkheden in Gelderland.
            </p>
          </div>

          <Card className="mb-8">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <MessageCircle className="h-5 w-5 text-primary" />
                Loxone Smart Home FAQ - Gelderland
              </CardTitle>
              <CardDescription>
                Ontdek waarom steeds meer huiseigenaren in Elst, Arnhem en omgeving kiezen voor Loxone
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Accordion type="single" collapsible className="w-full">
                {faqData.map((item, index) => (
                  <AccordionItem key={index} value={`item-${index}`}>
                    <AccordionTrigger className="text-left hover:text-primary">
                      {item.question}
                    </AccordionTrigger>
                    <AccordionContent className="text-muted-foreground leading-relaxed">
                      {item.answer}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </CardContent>
          </Card>

          <div className="text-center">
            <p className="text-muted-foreground mb-6">
              Heeft u nog andere vragen over Loxone of smart home mogelijkheden?
            </p>
            <Button 
              size="lg"
              onClick={() => {
                track("smarthome_faq_contact");
                (window as any).Calendly?.initPopupWidget?.({
                  url: 'https://calendly.com/sol-vi/new-meeting?primary_color=ff7800',
                  pageSettings: {
                    backgroundColor: 'ffffff',
                    hideEventTypeDetails: false,
                    hideLandingPageDetails: false,
                    primaryColor: 'ff7800',
                    textColor: '4d5055'
                  }
                });
              }}
            >
              <MessageCircle className="mr-2 h-4 w-4" />
              Plan Gratis Adviesgesprek
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SmartHomeFAQ;